import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'fun-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
})
export class SliderComponent implements OnInit, AfterViewInit {

  @Input() title: any;
  @Input() subtitle: any;
  @Input() projectList: any;
  @Input() type: any;
  @Input('featured') featured = false;
  @Input('cardType') cardType = 'generic';
  @Input() isFlexibleCompensation = false;
  @Input() showVerTodos = false;
  @Input() maxItems = 5;
  @Output() private eventClick = new EventEmitter<void>();
  @Output() verTodosClick = new EventEmitter<void>();

  @ViewChild('sliderRow') sliderRowRef!: ElementRef;

  displayList: any[] = [];
  showNav = false;
  isStart = true;
  isEnd = false;
  activeIndex = 0;

  constructor(public chdRef: ChangeDetectorRef) { }

  ngOnInit() {
    const shuffled = [...this.projectList].sort(() => Math.random() - 0.5);
    this.displayList = this.maxItems > 0 ? shuffled.slice(0, this.maxItems) : shuffled;
    this.showNav = this.projectList.length > this.maxItems;
    this.chdRef.detectChanges();
  }

  ngAfterViewInit() {
    if (!this.featured && this.sliderRowRef) {
      const el = this.sliderRowRef.nativeElement;
      this.isEnd = el.scrollWidth <= el.clientWidth + 4;
      this.chdRef.detectChanges();
    }
  }

  openNewProject(project: any) {
    this.eventClick.emit(project);
  }

  scrollToIndex(i: number) {
    const el = this.sliderRowRef?.nativeElement;
    if (!el) { return; }
    const cards = el.querySelectorAll('.slider-card');
    if (!cards[i]) { return; }
    (cards[i] as HTMLElement).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    this.activeIndex = i;
    this.chdRef.detectChanges();
  }

  onScroll() {
    const el = this.sliderRowRef?.nativeElement;
    if (!el) { return; }
    this.isStart = el.scrollLeft <= 4;
    this.isEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 4;
    const cards = Array.from(el.querySelectorAll('.slider-card')) as HTMLElement[];
    if (cards.length > 0) {
      const rowLeft = el.getBoundingClientRect().left;
      let closest = 0;
      let minDist = Infinity;
      cards.forEach((card, i) => {
        const dist = Math.abs(card.getBoundingClientRect().left - rowLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      });
      this.activeIndex = closest;
    }
    this.chdRef.detectChanges();
  }

}
